export default __webpack_public_path__ + "static/media/access-logout.9028a862.jpg";